import { type GridColDef } from '@mui/x-data-grid';

import { type ColumnOrderModel, type ColumnVisibilityModel } from '../types';

/**
 * Expands a column preset (the visible fields, in order) against the actual
 * column set: known preset fields come first and are visible; all remaining
 * columns are appended in their default relative order and hidden.
 * Preset fields that do not exist in the current column set are dropped.
 */
export function applyColumnPreset(
  columns: GridColDef[],
  orderedVisibleFields: readonly string[],
): {
  columnOrderModel: ColumnOrderModel;
  columnVisibilityModel: ColumnVisibilityModel;
} {
  const fields = columns.map(({ field }) => field);
  const presetFields = orderedVisibleFields.filter((field) =>
    fields.includes(field),
  );

  return {
    columnOrderModel: [
      ...presetFields,
      ...fields.filter((field) => !presetFields.includes(field)),
    ],
    columnVisibilityModel: Object.fromEntries(
      fields.map((field) => [field, presetFields.includes(field)]),
    ),
  };
}
